import { BaseAiChatEventRuntype } from 'bc-clickstream';
import type { BrowserTrackerCallbackEvent } from 'bc-clickstream/browser';

import { isFeatureFlagEnabled } from '../featureFlags';

export const handleAiChatEvent = (
  event: BrowserTrackerCallbackEvent
): BrowserTrackerCallbackEvent | null => {
  if (BaseAiChatEventRuntype.guard(event)) {
    const clickstreamAiChatEnabled = isFeatureFlagEnabled('CLICKSTREAM_AI_ASSIST_ENABLED');

    if (!clickstreamAiChatEnabled) {
      return null;
    }

    const clickstreamAiContentEnabled = isFeatureFlagEnabled(
      'CLICKSTREAM_AI_ASSIST_CONTENT_ENABLED'
    );

    if (!clickstreamAiContentEnabled) {
      const updatedEvent = {
        ...event,
        message: '',
        response: '',
      };
      return updatedEvent;
    }
  }
  return event;
};
